<i18n>
{
  "en": {
    "product": "Product master",
    "saleZone": "Sale zone master",
    "emptyMasterMessage": "There are no options available for master management."
  },
  "es": {
    "product": "Maestro de productos",
    "saleZone": "Maestro de zonas",
    "emptyMasterMessage":  "No hay ninguna opcion disponibles para gestion de maestros"
  }
}
</i18n>

<template>
  <div>
    <v-layout row wrap justify-space-around>
      <dynameat-management-button v-for="button in buttonList" :key="button.action"
                                  action="handleAction" :title="button.title"
                                  :icon="button.icon" :show-badge="button.showBadge"
                                  :disabled="button.disabled" v-on="$listeners"
                                  :actionParams="button.routeInfo.name"
                                  class="btn danger dynameatManagementButton">
      </dynameat-management-button>
      <div v-if="buttonList.length === 0">
        <h2>{{$t('emptyMasterMessage')}}</h2>
      </div>
    </v-layout>
  </div>
</template>

<script>
import Vue from 'vue';
import DynameatManagementButton from '@dynameat/components/DynameatManagementButton';
import Component from 'vue-class-component';
import { Components } from '@core/helpers/decorators';
import {PermissionController} from "@core/permissions";

@Component
@Components({ DynameatManagementButton })
export default class MasterManagementPanel extends Vue {
  get buttonList() {
    const routes = [
      {
        disabled: false,
        title: this.$t('product'),
        icon: 'mdi-food-fork-drink',
        showBadge: false,
        routeInfo: { name: 'product' }
      },
      {
        disabled: false,
        title: this.$t('saleZone'),
        icon: 'mdi-table-furniture',
        showBadge: false,
        routeInfo: { name: 'saleZone' }
      }
    ];
    return routes.filter((route) => PermissionController.getInstance().isAllowed(route.routeInfo.name));
  }
}
</script>
